<script>
import ProductSelect from "./product_select.vue"
import { api } from "./api"
export default {
  props: ["id"],
  data() {
    return {
      member: {},
      loading: false,
      extra: false,
      valid: true
    };
  },

  components: {
    ProductSelect
  },

  methods: {
    submit() {
      if (this.loading || !this.valid) {
        return;
      }
      this.loading = true;
      api.put(`members/${this.id}`, { member: this.member }).then(
        () => {
          window.location = "/phonebook/members";
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
  computed: {
    product_limit() {
      if (this.member.p_email && this.member.p_qq) {
        return 3;
      } else {
        return 2;
      }
    },
  },
  created() {
    api.get(`members/${this.id}`).then(({ data }) => {
      this.member = data;
      if (this.member.p_name) {
        this.extra = true;
      } else {
        this.member.p_name = data.username;
      }
    });
  },
};
</script>
<template>
  <div>
    <div class="container">
      <form>
        <div class="form-group">
          <label for="">姓名</label>
          <input class="form-control" v-model="member.p_name" placeholder="请输入姓名" :minlength="2" :maxlength="10"
            required icon name="realname" />
        </div>

        <div class="form-group">
          <label class="control-label">主营产品</label>
          <ProductSelect v-model="member.main_product_ids" :max="product_limit" :min="0">
          </ProductSelect>
        </div>

        <div class="form-group">
          <label for="">手机号码</label>
          <input class="form-control" v-model="member.p_phone" placeholder="请输入手机号码" :minlength="11" :maxlength="11"
            required name="phone" />
        </div>

        <div class="form-group">
          <label for="">公司</label>
          <input class="form-control" v-model="member.p_company" placeholder="请输入公司名称" :minlength="3" :maxlength="25"
            required icon name="company" />

        </div>
        <div class="form-group">
          <label for="">职务</label>
          <input class="form-control" v-model="member.p_position" placeholder="请输入职务" :minlength="2" :maxlength="5"
            required icon name="company" />
        </div>

        <div v-if="extra">
          <div class="form-group">
            <label for="">邮箱</label>
            <input class="form-control" v-model="member.p_email" placeholder="请输入邮箱" />
          </div>
          <div class="form-group">
            <label for="">QQ</label>
            <input class="form-control" v-model="member.p_qq" label="QQ" placeholder="请输入QQ" />

          </div>

          <div class="form-group">
            <label for="">备注</label>
            <textarea class="form-control" v-model="member.p_remark" label="备注" type="textarea"></textarea>
          </div>

        </div>
      </form>
    </div>
    <div class="space"></div>
    <footer>
      <div class="item2 pull-left" @click="submit">{{ valid? "点此保存我的信息": "请完善资料后提交" }}</div>
      <a href="/phonebook/members">
        <div class="item2 pull-left">
          返回
          <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
        </div>
      </a>
    </footer>
  </div>
</template>
